import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useState } from "react";

var useUserParams = function useUserParams() {
  var _useState = useState({
    Size: 10,
    Index: 1,
    orderBy: 'UserName',
    orderDirection: 'asc',
    terms: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      userParams = _useState2[0],
      setUserParams = _useState2[1];

  var updateUserParams = useCallback(function (params) {
    setUserParams(_objectSpread(_objectSpread({}, userParams), params));
  }, [userParams]);
  return [userParams, updateUserParams];
};

export default useUserParams;